/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lot_Debt_Fill_Col_Sold_AtInputs */

const vi_lot_debt_fill_col_sold_at = /** @type {(inputs: Lot_Debt_Fill_Col_Sold_AtInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bán lúc`)
};

/**

* @param {Lot_Debt_Fill_Col_Sold_AtInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const lot_debt_fill_col_sold_at = /** @type {((inputs?: Lot_Debt_Fill_Col_Sold_AtInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lot_Debt_Fill_Col_Sold_AtInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_lot_debt_fill_col_sold_at(inputs)
});